import MenuIcon from '@mui/icons-material/Menu'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { useReducerContext, ActionKind } from 'hooks/useReducerContext'
import { useState } from 'react'

const BarMenuButton = () => {
  const [_ctx, dispatch] = useReducerContext()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const openLogoutDialog = () => {
    dispatch({ type: ActionKind.LOGOUT_OPEN })
  }

  const handleMenuItemClick = () => {
    closeMenu()
    openLogoutDialog()
  }

  return (
    <>
      <IconButton
        sx={{ position: 'absolute', right: 0, top: 5, color: 'white' }}
        aria-label="menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem onClick={handleMenuItemClick}>ログアウト</MenuItem>
      </Menu>
    </>
  )
}

export default BarMenuButton
